import AddIcon from "@mui/icons-material/Add";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  FormControl,
  MenuItem,
  Pagination,
  Select,
  TableCell,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { useTheme } from "@mui/styles";
import moment from "moment";
import "moment/locale/de";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { DeleteFaq } from "../../../../actions/machines";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { Theme247 } from "../../../../styles/Theme247";
import {
  GetReminderValue,
  GetRepetitionValue,
  getIntervalsInMs,
} from "../../../../types/index";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { EmptyState } from "../../EmptyStat";

import { chunk } from "lodash";
import TextIcon from "../../../Newcalender/TextIcon";
import { setItem } from "../../../../utils/DataProtection";
// import { getUnits } from "../../../../shared-functions/units";

import { getUnits } from "../../../../actions/counters";
import { Tooltip } from "antd";
import { truncateWithEllipses } from "../../../../utils/helpers";

moment.locale("de");
const useStyles1 = makeStyles()((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
    display: "flex",
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

//sorting functions
function descendingComparator(a, b, orderBy) {
  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el.maintenancetask, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0].startingfrom, b[0].startingfrom);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "1",
    numeric: false,
    disablePadding: false,
    sortIcon: "show",
    label: "Titel",
    color: "rgba(14, 63, 81, 1)",
  },
  {
    id: "2",
    numeric: false,
    disablePadding: false,
    label: "Nächste Durchführung",
    color: "rgba(14, 63, 81, 1)",
  },
  {
    id: "3",
    numeric: false,
    disablePadding: false,
    label: "Wiederholung",
    color: "rgba(14, 63, 81, 1)",
  },
  {
    id: "4",
    numeric: false,
    disablePadding: false,
    label: "Erinnerung",
    color: "rgba(14, 63, 81, 1)",
  },
  {
    id: "5",
    numeric: false,
    disablePadding: false,
    sortIcon: "show",
    label: "Kategorie",
    color: "rgba(14, 63, 81, 1)",
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ color: headCell.color, fontSize: "15px" }}
          >
            {headCell.label}
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            ></TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default connect(
  ({ i18n, machines, profile, units }) => ({ i18n, machines, profile, units }),
  { DeleteFaq, getUnits }
)((props) => {
  const { units } = props;
  //const classes = useStyles2();
  const store = useStore().getState();

  const [latestCounterValue, setLatestCounterValue] = useState(0);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [sortingArray, setsortingArray] = useState([]);
  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    window?.blurAll();
  };

  /*
   * Styles
   */
  const useStyles = makeStyles()((theme) => ({
    documentationContainer: {
      padding: "28px 24px",

      "& .CardButton": {
        marginRight: 24,
      },
    },
    sectionHeadlineSub: {
      marginTop: 20,
      marginBottom: 20,
    },
    cardclass: {
      border: 0,
    },
  }));
  const { classes } = useStyles();
  const i18n = props.i18n;

  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props.machines.equipment.hasmaintenancetask.map(
        (n) => n.maintenancetask.startingfrom
      );
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  //calendar

  const map = {};

  if (
    props.machines?.equipment?.hasmaintenancetask &&
    props.machines?.equipment?.hasmaintenancetask?.length > 0
  ) {
    let startcalendarTS = 0;
    let stopcalendarTS = 0;

    startcalendarTS = Number(
      moment()
        .clone()
        .startOf("month")
        .format("x")
    );
    stopcalendarTS = Number(
      moment()
        .clone()
        .endOf("month")
        .add("6", "months")
        .format("x")
    );

    props.machines.equipment.hasmaintenancetask.map((m, k) => {
      let i = 1;
      /* if(m.maintenancetask.repetitioninterval=='1m'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('1', 'month').format('x'))
            }
            else if(m.maintenancetask.repetitioninterval=='3m'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('3', 'months').format('x'))
            }
            else if(m.maintenancetask.repetitioninterval=='6m'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('6', 'months').format('x'))
            }
            else if(m.maintenancetask.repetitioninterval=='1y'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('12', 'months').format('x'))
            }
            else if(m.maintenancetask.repetitioninterval=='18m'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('18', 'months').format('x'))
            }
            else if(m.maintenancetask.repetitioninterval=='24m'){
                stopcalendarTS = Number( moment().clone().endOf('month').add('24', 'months').format('x'))
            } */

      let x = m.maintenancetask.startingfrom;
      //array of occurance
      const arrayofOccourance = [];

      if (m.maintenancetask.repetitioninterval !== "onetime") {
        if (
          m.maintenancetask.repetitioninterval === undefined ||
          m.maintenancetask.repetitioninterval === "" ||
          m.maintenancetask.repetitioninterval === null
        ) {
          return;
        }
        while (x < stopcalendarTS) {
          if (x > startcalendarTS) {
            arrayofOccourance.push(moment(x).format("M"));
          }

          if (m.maintenancetask.repetitioninterval == "1w") {
            x = Number(
              moment(x)
                .add("weeks", "1")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "2w") {
            x = Number(
              moment(x)
                .add("weeks", "2")
                .format("x")
            );
          }
           else if (m.maintenancetask.repetitioninterval == "6w") {
            x = Number(
              moment(x)
                .add("weeks", "6")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "1m") {
            x = Number(
              moment(x)
                .add("1", "month")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "2m") {
            x = Number(
              moment(x)
                .add("2", "month")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "3m") {
            x = Number(
              moment(x)
                .add("3", "months")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "6m") {
            x = Number(
              moment(x)
                .add("6", "months")
                .format("x")
            );
          } else if (
            m.maintenancetask.repetitioninterval == "1y" ||
            m.maintenancetask.repetitioninterval == "12m"
          ) {
            x = Number(
              moment(x)
                .add("12", "months")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "18m") {
            x = Number(
              moment(x)
                .add("18", "months")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "24m") {
            x = Number(
              moment(x)
                .add("24", "months")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "36m") {
            x = Number(
              moment(x)
                .add("36", "months")
                .format("x")
            );
          } else if (m.maintenancetask.repetitioninterval == "48m") {
            x = Number(
              moment(x)
                .add("48", "months")
                .format("x")
            );
          }
        }
      } else {
        arrayofOccourance.push({
          occMonth: moment(x).format("M"),
          occYear: moment(x).format("YYYY"),
          occTS: x,
        });
      }
      //loop ends here

      //check category is exist or not
      const key =
        m.maintenancetask.hascategory &&
        m.maintenancetask.hascategory[0].maintenancecategory.name.de;
      if (!isEmpty(map) && key in map) {
        //add swim lane
        //add swim lane
        const swimLane = {
          task: m.maintenancetask,
          occurance: arrayofOccourance,
        };
        const key =
          m.maintenancetask.hascategory &&
          m.maintenancetask.hascategory[0].maintenancecategory.name.de;
        const swimLaneKey = "swimLanes";
        const swimLaneArray = map[key][swimLaneKey];
        swimLaneArray.push(swimLane);
        map[key] = {
          name:
            m.maintenancetask.hascategory &&
            m.maintenancetask.hascategory[0].maintenancecategory.name,
          colorcode:
            m.maintenancetask.hascategory &&
            m.maintenancetask.hascategory[0].maintenancecategory.colorcode,
        };
        map[key][swimLaneKey] = swimLaneArray;
      } else {
        //add swim lane
        const swimLane = {
          task: m.maintenancetask,
          occurance: arrayofOccourance,
        };
        const key =
          m.maintenancetask.hascategory &&
          m.maintenancetask.hascategory[0].maintenancecategory.name.de;
        const swimLaneKey = "swimLanes";
        const swimLaneArray = [];
        swimLaneArray.push(swimLane);
        map[key] = {
          name:
            m.maintenancetask.hascategory &&
            m.maintenancetask.hascategory[0].maintenancecategory.name,
          colorcode:
            m.maintenancetask.hascategory &&
            m.maintenancetask.hascategory[0].maintenancecategory.colorcode,
        };
        map[key][swimLaneKey] = swimLaneArray;
      }
      i++;
    });
    //ends outer loop here
    const ok = 0;
  }

  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  const monthsByName = [
    "January",
    "Febraury",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthsByID = ["5", "6", "7", "8", "9", "10"];

  const [state, setState] = React.useState({
    wrek: "",
    name: "hai",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const render_td = (lane, id, mon) => {
    const date = moment(lane.task.startingfrom).format("DD"); // DD
    const title = moment(lane.task.startingfrom).format("LL");
    return (
      <td className={id % 2 == 0 ? "brdr-none" : "has-border"}>
        {lane.occurance.map(
          (occ, k) =>
            occ == mon && (
              <div
                key={k}
                className="td-pill pill"
                style={{ marginLeft: `${1.8 * date}px` }}
              >
                <div className="pill-text" title={title}>
                  {lane.task.title}
                </div>
              </div>
            )
        )}
      </td>
    );
  };

  const getNextDueDate = (mtnodeid, category) => {
    //moment(i.startingfrom).format('ddd DD.MM.YYYY')
    let nextMonth = 0;

    let ReturnTS = 0;
    let temparray = sortingArray;
    Object.values(map).map((m, k) => {
      if (m.name == category) {
        const filtered_swimLane =
          m.swimLanes && m.swimLanes.filter((sl) => sl.task.nodeid == mtnodeid);
        nextMonth = filtered_swimLane[0].occurance[0];
        if (nextMonth > 0) {
          const startingFrom = filtered_swimLane[0].task.startingfrom;

          const currentMonth = Number(moment(startingFrom).format("MM"));
          const subs_month = nextMonth - currentMonth;
          if (subs_month > 1) {
            ReturnTS = Number(
              moment(startingFrom)
                .add(subs_month, "months")
                .format("x")
            );
          } else {
            ReturnTS = Number(
              moment(startingFrom)
                .add(subs_month, "month")
                .format("x")
            );
          }
        } else {
          if (filtered_swimLane[0].task.repetitioninterval == "1w") {
            x = Number(
              moment(x)
                .add("1", "weeks")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "2w") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("2", "weeks")
                .format("x")
            );
          }
           else if (filtered_swimLane[0].task.repetitioninterval == "6w") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("6", "weeks")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "1m") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("1", "month")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "3m") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("3", "months")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "6m") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("6", "months")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "1y") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("12", "months")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "18m") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("18", "months")
                .format("x")
            );
          } else if (filtered_swimLane[0].task.repetitioninterval == "24m") {
            ReturnTS = Number(
              moment(filtered_swimLane[0].task.startingfrom)
                .add("24", "months")
                .format("x")
            );
          }
        }
      } //end if here
    }); //end loop here
    //temparray.push(ReturnTS)
    //setsortingArray(temparray)
    return moment(ReturnTS).format("ddd DD.MM.YYYY");
  };

  let paginationchunks = chunk(
    props?.machines?.equipment?.hasmaintenancetask,
    rowsPerPage
  );

  /* console.log(props.machines.equipment, "props.machines.equipment"); */

  function checkOverDue(ts) {
    // const ts = moment(startingfrom).set('month', +taskMonth - 1).format("x");
    /* console.log(ts, moment(startingfrom).format("DD.MM.YYYY"), taskMonth) */
    if (ts > Date.now()) {
      return false;
    } else {
      return true;
    }
  }

  function handleNotificationClick(item) {
    const notificationnodeid = item.nodeid;
    //props.getNotification({nodeid:notificationnodeid},'GETSINGLENOTIFICATION')
    setItem("notification-nodeid", item.nodeid);
    setItem("chatroomnodeid", item.haschatroom?.[0]?.chatroom.nodeid);
  }

  function getCounterUnit(counterNodeId, counters) {
    // Extract the counter node ID from hasmaintenancetask -> triggeringevent[0]

    if (!counterNodeId) {
      console.error("No counter node ID found in triggering event.");
      return null;
    }

    // Find the counter object in isnotificationof

    if (!counters) {
      console.error("No counters.");
      return null;
    }
    const counter = counters.find((c) => c.counter.nodeid === counterNodeId);

    if (!counter) {
      console.error("No matching counter found.");
      return null;
    }

    // Extract the unitId from hascountertype

    const unitId =
      counter.counter.hascountertype?.[0]?.countertype?.unit?.unitid !==
      undefined
        ? counter.counter.hascountertype?.[0]?.countertype?.unit?.unitid
        : counter.counter.hascountertype?.[0]?.countertype?.unit?.unit?.unitId;

    if (!unitId) {
      console.error("No unit ID found for the counter.");
      return null;
    }

    if (!units) {
      console.error("No units found.");
      return null;
    }
    // Find the unit details from units array
    const unit = units.find((u) => u.unitId === unitId);

    return unit ? unit?.displayName?.plural[store.language] : "";
  }

  const getLatestCounterValue = (counterNodeid) => {
    let counterId = counterNodeid;
    let targetCounter =
      props.machines.equipment?.hascounter &&
      props.machines.equipment?.hascounter.filter((counter) => {
        return counter.counter.nodeid === counterId;
      });

    if (targetCounter?.length) {
      const counters = targetCounter[0]?.counter?.values;

      if (!counters || counters.length === 0) {
        return null; // Return null if no values exist
      }

      // Find the sub-array with the highest timestamp
      const latestEntry = counters.reduce(
        (max, entry) => (entry[1] > max[1] ? entry : max),
        counters[0]
      );

      return latestEntry[0];
    }
  };

  useEffect(() => {
    if (units.length === 0) {
      props.getUnits("UNITS");
    }
  }, []);

  return (
    <>
      {props?.machines?.equipment?.hasmaintenancetask?.length > 0 ? (
        <div className={classes.documentationContainer}>
          <div className="MO_maintenance">
            <div className={_s(Theme247.sectionHeader)} style={{ margin: 0 }}>
              <Typography variant="h1">{i18n.maintenance}</Typography>
            </div>

            <div>
              {canUserPerformAction(
                props.profile?.features?.["equipment.maintenancetask"],
                "create"
              ) && (
                <Link
                  to="/create-maintenance-task"
                  state={{
                    pageType: "add",
                    from: "fo",
                    nodeid: props?.machines?.equipment?.nodeid,
                    equipmentcurrency:
                      props?.machines?.equipment?.equipmentcurrency,
                  }}
                >
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    color="primary"
                  >
                    {i18n.new_maintenance}
                  </Button>
                </Link>
              )}
            </div>
          </div>
          <div className="MO_maintenance_desc">{i18n.maintenance_desc}</div>

          {canUserPerformAction(
            props.profile?.features?.["equipment.maintenancetask"],
            "read"
          ) && (
            <>
              <Table className="routineMaintenanceTable">
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={
                    props.machines &&
                    props.machines?.equipment?.hasmaintenancetask &&
                    props.machines?.equipment?.hasmaintenancetask.length
                  }
                />
                <TableBody>
                  {props.machines &&
                  props.machines?.equipment?.hasmaintenancetask &&
                  props.machines?.equipment?.hasmaintenancetask.length > 0
                    ? (rowsPerPage > 0
                        ? stableSort(
                            props.machines.equipment.hasmaintenancetask,
                            getComparator(order, orderBy)
                          ).slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : props.machines.equipment.hasmaintenancetask
                      ).map((i, k) => {
                        let isCounterBasedMaintenanceTask =
                          i.triggertype === "counter";

                        let x = i.nextdueat;

                        // const today =
                        //   moment(new Date().setHours(0, 0, 0, 0)).unix() * 1000;

                        const today = moment(new Date()).unix() * 1000;

                        if (
                          i.repetitioninterval !== "onetime" &&
                          i.repetitioninterval !== null &&
                          (i.triggertype === "time" ||
                            i.triggertype === null ||
                            i.triggertype === "")
                        ) {
                          while (true) {
                            let x1 = x - getIntervalsInMs(i.repetitioninterval);
                            if (x1 < today) {
                              break;
                            } else {
                              x = x1;
                            }
                          }
                        } else {
                          if (i.nextdueat < 0) {
                            x = i.startingfrom;
                          }
                        }

                        let finalDate = x;

                        return (
                          <TableRow key={k}>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{ color: "#38748D", width: "30%" }}
                            >
                              {canUserPerformAction(
                                props.profile?.features?.[
                                  "equipment.maintenancetask"
                                ],
                                "update"
                              ) ? (
                                <Link
                                  equipmentcurrency={
                                    props?.machines?.equipment
                                      ?.equipmentcurrency
                                  }
                                  to="/edit-maintenance-task"
                                  state={{
                                    from: "fo",
                                    costs: i?.hascost,
                                    safetynotice: i.safetynotice,
                                    equipmentNodeId:
                                      props.machines?.equipment?.nodeid,
                                    title: i?.title,

                                    safetynotice: i.safetynotice,

                                    maintenancetaskid: i?.maintenancetaskid,
                                    title: i?.title,

                                    categorynodeid:
                                      i?.hascategory &&
                                      i?.hascategory[0]?.maintenancecategory
                                        .nodeid,
                                    startingfrom: i.startingfrom,
                                    repetition: i.repetitioninterval,
                                    triggertype: i.triggertype
                                      ? i.triggertype
                                      : "time",
                                    triggeringevent: i.triggeringevent,
                                    reminder: i.reminder,
                                    description:
                                      i?.hasworkflow &&
                                      i?.hasworkflow[0]?.workflow
                                        .hasworkflowstep &&
                                      i?.hasworkflow[0]?.workflow
                                        .hasworkflowstep[0]?.workflowstep
                                        ?.description,
                                    pageType: "edit",
                                    workflowAttachments:
                                      i?.hasworkflow &&
                                      i?.hasworkflow[0]?.workflow
                                        .hasworkflowstep &&
                                      i.hasworkflow[0]?.workflow
                                        .hasworkflowstep[0]?.workflowstep
                                        .hasattachment,
                                    workflowstepnodeid:
                                      i?.hasworkflow &&
                                      i?.hasworkflow[0]?.workflow
                                        .hasworkflowstep &&
                                      i.hasworkflow[0]?.workflow
                                        .hasworkflowstep[0]?.workflowstep
                                        .nodeid,
                                    maintenancetasknodeid: i.nodeid,
                                    workflownodeid:
                                      i?.hasworkflow &&
                                      i.hasworkflow[0]?.workflow.nodeid,
                                    equipmentNodeId:
                                      props.machines?.equipment?.nodeid,
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      <div>
                                        {i.maintenancetaskid
                                          ? i.maintenancetaskid
                                          : ""}{" "}
                                        {i?.title}
                                      </div>
                                    }
                                  >
                                    {truncateWithEllipses(
                                      (i.maintenancetaskid
                                        ? i.maintenancetaskid + " "
                                        : "") + i.title,
                                      28
                                    )}
                                  </Tooltip>
                                </Link>
                              ) : (
                                i?.title
                              )}
                            </TableCell>

                            {/* <TableCell align="left">{getNextDueDate(i.nodeid, i?.hascategory && i?.hascategory[0]?.maintenancecategory?.name)}</TableCell> */}
                            <TableCell>
                              <div>
                                {isCounterBasedMaintenanceTask ? (
                                  i.repetitioninterval !== "" &&
                                  i.repetitioninterval !== null ? (
                                    <div>
                                      <div>
                                        {moment(finalDate).format("DD.MM.YYYY")}
                                      </div>
                                      <div>
                                        {parseFloat(
                                          i?.triggeringevent?.[1] +
                                            i?.triggeringevent?.[3]
                                        ) +
                                          " " +
                                          getCounterUnit(
                                            i?.triggeringevent?.[0],
                                            props.machines.equipment.hascounter
                                          )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <div>
                                        {parseFloat(
                                          i?.triggeringevent?.[1] +
                                            i?.triggeringevent?.[3]
                                        ) +
                                          " " +
                                          getCounterUnit(
                                            i?.triggeringevent?.[0],
                                            props.machines.equipment.hascounter
                                          )}
                                      </div>
                                    </div>
                                  )
                                ) : i.nextdueat <= 0 ? (
                                  ""
                                ) : (
                                  moment(i.nextdueat).format("DD.MM.YYYY")
                                )}
                              </div>

                              {/* {targetNotification.length === 0 ? (
                                <div
                                  key={k}
                                  className="bxShadow newCalenderPill"
                                  style={{
                                    width: "170px",
                                    border: isCounterBasedMaintenanceTask && no_repitiotion_and_reminder ? "1px solid rgba(0, 0, 0, 0.12)"  :   checkOverDue(i.startingfrom)
                                      ? "1px solid #FF3D00"
                                      : "1px solid rgba(0, 0, 0, 0.12)",
                                  }}
                                >
                                  <div
                                    className="header"
                                    style={{
                                      textDecorationLine:
                                        targetNotification[0]?.notification
                                          .status === 2
                                          ? "line-through"
                                          : "",
                                    }}
                                  >
                                    {moment(
                                      i.dueuntil ? i.dueuntil : i.startingfrom
                                    ).format("DD.MM.YYYY")}
                                  </div>

                                  <TextIcon
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    iconStyle={{ transform: "" }}
                                    svg={
                                      <svg
                                        width="12"
                                        height="15"
                                        viewBox="0 0 12 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4 10.5C3.53333 10.5 3.13889 10.3389 2.81667 10.0166C2.49444 9.69442 2.33333 9.29998 2.33333 8.83331C2.33333 8.36665 2.49444 7.9722 2.81667 7.64998C3.13889 7.32776 3.53333 7.16665 4 7.16665C4.46667 7.16665 4.86111 7.32776 5.18333 7.64998C5.50556 7.9722 5.66667 8.36665 5.66667 8.83331C5.66667 9.29998 5.50556 9.69442 5.18333 10.0166C4.86111 10.3389 4.46667 10.5 4 10.5ZM1.33333 14.1666C0.966667 14.1666 0.652778 14.0361 0.391667 13.775C0.130556 13.5139 0 13.2 0 12.8333V3.49998C0 3.13331 0.130556 2.81942 0.391667 2.55831C0.652778 2.2972 0.966667 2.16665 1.33333 2.16665H2V1.49998C2 1.31109 2.06389 1.15276 2.19167 1.02498C2.31944 0.897202 2.47778 0.833313 2.66667 0.833313C2.85556 0.833313 3.01389 0.897202 3.14167 1.02498C3.26944 1.15276 3.33333 1.31109 3.33333 1.49998V2.16665H8.66667V1.49998C8.66667 1.31109 8.73056 1.15276 8.85833 1.02498C8.98611 0.897202 9.14444 0.833313 9.33333 0.833313C9.52222 0.833313 9.68056 0.897202 9.80833 1.02498C9.93611 1.15276 10 1.31109 10 1.49998V2.16665H10.6667C11.0333 2.16665 11.3472 2.2972 11.6083 2.55831C11.8694 2.81942 12 3.13331 12 3.49998V12.8333C12 13.2 11.8694 13.5139 11.6083 13.775C11.3472 14.0361 11.0333 14.1666 10.6667 14.1666H1.33333ZM1.33333 12.8333H10.6667V6.16665H1.33333V12.8333ZM1.33333 4.83331H10.6667V3.49998H1.33333V4.83331Z"
                                          fill="black"
                                          fillOpacity="0.87"
                                        />
                                      </svg>
                                    }
                                    text={
                                      isCounterBasedMaintenanceTask && no_repitiotion_and_reminder ? "Geplant" : checkOverDue(i.startingfrom)
                                        ? "Überfällig"
                                        : "Geplant"
                                    }
                                    textColor={
                                      isCounterBasedMaintenanceTask && no_repitiotion_and_reminder ? "rgba(0, 0, 0, 0.5)" :  checkOverDue(i.startingfrom)
                                        ? "#FF3D00"
                                        : "rgba(0, 0, 0, 0.5)"
                                    }
                                  />
                                </div>
                              ) : (
                                <>
                                  {targetNotification[0]?.notification
                                    .status === 2 ? (
                                    <div
                                      key={k}
                                      className="bxShadow newCalenderPill"
                                      style={{
                                        width: "170px",
                                        border: "1px solid rgba(0, 0, 0, 0.12)",
                                      }}
                                    >
                                      <div
                                        className="header"
                                        style={{
                                          textDecorationLine: "",
                                        }}
                                      >
                                        {moment(i.nextdueat).format(
                                          "DD.MM.YYYY"
                                        )}
                                      </div>

                                      <TextIcon
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        iconStyle={{ transform: "" }}
                                        svg={
                                          <svg
                                            width="12"
                                            height="15"
                                            viewBox="0 0 12 15"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M4 10.5C3.53333 10.5 3.13889 10.3389 2.81667 10.0166C2.49444 9.69442 2.33333 9.29998 2.33333 8.83331C2.33333 8.36665 2.49444 7.9722 2.81667 7.64998C3.13889 7.32776 3.53333 7.16665 4 7.16665C4.46667 7.16665 4.86111 7.32776 5.18333 7.64998C5.50556 7.9722 5.66667 8.36665 5.66667 8.83331C5.66667 9.29998 5.50556 9.69442 5.18333 10.0166C4.86111 10.3389 4.46667 10.5 4 10.5ZM1.33333 14.1666C0.966667 14.1666 0.652778 14.0361 0.391667 13.775C0.130556 13.5139 0 13.2 0 12.8333V3.49998C0 3.13331 0.130556 2.81942 0.391667 2.55831C0.652778 2.2972 0.966667 2.16665 1.33333 2.16665H2V1.49998C2 1.31109 2.06389 1.15276 2.19167 1.02498C2.31944 0.897202 2.47778 0.833313 2.66667 0.833313C2.85556 0.833313 3.01389 0.897202 3.14167 1.02498C3.26944 1.15276 3.33333 1.31109 3.33333 1.49998V2.16665H8.66667V1.49998C8.66667 1.31109 8.73056 1.15276 8.85833 1.02498C8.98611 0.897202 9.14444 0.833313 9.33333 0.833313C9.52222 0.833313 9.68056 0.897202 9.80833 1.02498C9.93611 1.15276 10 1.31109 10 1.49998V2.16665H10.6667C11.0333 2.16665 11.3472 2.2972 11.6083 2.55831C11.8694 2.81942 12 3.13331 12 3.49998V12.8333C12 13.2 11.8694 13.5139 11.6083 13.775C11.3472 14.0361 11.0333 14.1666 10.6667 14.1666H1.33333ZM1.33333 12.8333H10.6667V6.16665H1.33333V12.8333ZM1.33333 4.83331H10.6667V3.49998H1.33333V4.83331Z"
                                              fill="black"
                                              fillOpacity="0.87"
                                            />
                                          </svg>
                                        }
                                        text={"Geplant"}
                                        textColor={"rgba(0, 0, 0, 0.5)"}
                                      />
                                    </div>
                                  ) : (
                                    <Link
                                      to="/notification-details"
                                      state={{
                                        nodeid:
                                          targetNotification[0]?.notification
                                            .nodeid,
                                        from: "Maintenance",
                                        equipmentNodeId:
                                          props.machines?.equipment?.nodeid,
                                      }}
                                      onClick={() =>
                                        handleNotificationClick(
                                          targetNotification[0]?.notification
                                        )
                                      }
                                    >
                                      <div
                                        key={k}
                                        className="bxShadow newCalenderPill"
                                        style={{
                                          width: "170px",
                                          height: "fit-content",
                                          marginLeft: "2px",
                                          marginTop: "0px",
                                          border:
                                          isCounterBasedMaintenanceTask  ? "1px solid #6FA03B" : checkOverDue(counter_based_repitiotion_and_reminder ? targetNotification[0]?.notification.dueuntil : i.startingfrom) &&
                                            targetNotification[0]?.notification
                                              .status !== 2
                                              ? "1px solid  #FF3D00"
                                              : targetNotification[0]
                                                  ?.notification.status === 2
                                              ? "1px solid #0000001F"
                                              : "1px solid #6FA03B",
                                        }}
                                      >
                                        <div
                                          className="header"
                                          style={{
                                            textDecorationLine:
                                              targetNotification[0]
                                                ?.notification.status === 2
                                                ? "line-through"
                                                : "",
                                          }}
                                        >
                                          {moment(
                                            targetNotification[0].notification
                                              .dueuntil
                                              ? targetNotification[0]
                                                  .notification.dueuntil
                                              : targetNotification[0]
                                                  .notification.startingfrom
                                          ).format("DD.MM.YYYY")}
                                        </div>

                                        {targetNotification[0]?.notification
                                          .status === 2 ? (
                                          <TextIcon
                                            svg={
                                              <svg
                                                width="14"
                                                height="15"
                                                viewBox="0 0 14 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M6.06634 8.70004L4.61634 7.25004C4.49412 7.12782 4.34145 7.0696 4.15834 7.07537C3.97479 7.08071 3.8219 7.14449 3.69967 7.26671C3.57745 7.38893 3.51634 7.54449 3.51634 7.73337C3.51634 7.92226 3.57745 8.07782 3.69967 8.20004L5.59967 10.1C5.7219 10.2223 5.87745 10.2834 6.06634 10.2834C6.25523 10.2834 6.41079 10.2223 6.53301 10.1L10.3163 6.31671C10.4386 6.19449 10.497 6.0416 10.4917 5.85804C10.4859 5.67493 10.4219 5.52226 10.2997 5.40004C10.1775 5.27782 10.0219 5.21671 9.83301 5.21671C9.64412 5.21671 9.48856 5.27782 9.36634 5.40004L6.06634 8.70004ZM6.99967 14.1667C6.07745 14.1667 5.21079 13.9916 4.39967 13.6414C3.58856 13.2916 2.88301 12.8167 2.28301 12.2167C1.68301 11.6167 1.20812 10.9112 0.858341 10.1C0.508119 9.28893 0.333008 8.42226 0.333008 7.50004C0.333008 6.57782 0.508119 5.71115 0.858341 4.90004C1.20812 4.08893 1.68301 3.38337 2.28301 2.78337C2.88301 2.18337 3.58856 1.70826 4.39967 1.35804C5.21079 1.00826 6.07745 0.833374 6.99967 0.833374C7.9219 0.833374 8.78856 1.00826 9.59967 1.35804C10.4108 1.70826 11.1163 2.18337 11.7163 2.78337C12.3163 3.38337 12.7912 4.08893 13.141 4.90004C13.4912 5.71115 13.6663 6.57782 13.6663 7.50004C13.6663 8.42226 13.4912 9.28893 13.141 10.1C12.7912 10.9112 12.3163 11.6167 11.7163 12.2167C11.1163 12.8167 10.4108 13.2916 9.59967 13.6414C8.78856 13.9916 7.9219 14.1667 6.99967 14.1667ZM6.99967 12.8334C8.47745 12.8334 9.7359 12.314 10.775 11.2754C11.8137 10.2363 12.333 8.97782 12.333 7.50004C12.333 6.02226 11.8137 4.76382 10.775 3.72471C9.7359 2.68604 8.47745 2.16671 6.99967 2.16671C5.5219 2.16671 4.26367 2.68604 3.22501 3.72471C2.1859 4.76382 1.66634 6.02226 1.66634 7.50004C1.66634 8.97782 2.1859 10.2363 3.22501 11.2754C4.26367 12.314 5.5219 12.8334 6.99967 12.8334Z"
                                                  fill="black"
                                                  fillOpacity="0.5"
                                                />
                                              </svg>
                                            }
                                            text={"Durchgeführt"}
                                            textColor={"rgba(0, 0, 0, 0.5)"}
                                          />
                                        ) : (
                                          <TextIcon
                                            svg={
                                              checkOverDue(counter_based_repitiotion_and_reminder ? targetNotification[0]?.notification.dueuntil : i.startingfrom) ? (
                                                <svg
                                                  width="12"
                                                  height="13"
                                                  viewBox="0 0 12 13"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M9.91667 12.0833C9.69444 12.0833 9.48333 12.0418 9.28333 11.9587C9.08333 11.8751 8.9 11.75 8.73333 11.5833L5.4 8.23333C5.17778 8.32222 4.95289 8.38889 4.72533 8.43333C4.49733 8.47778 4.25556 8.5 4 8.5C2.88889 8.5 1.94444 8.11111 1.16667 7.33333C0.388889 6.55556 0 5.61111 0 4.5C0 4.1 0.0555555 3.71933 0.166667 3.358C0.277778 2.99711 0.433333 2.65556 0.633333 2.33333L3.06667 4.76667L4.26667 3.56667L1.83333 1.13333C2.15556 0.933333 2.49711 0.777778 2.858 0.666667C3.21933 0.555556 3.6 0.5 4 0.5C5.11111 0.5 6.05556 0.888889 6.83333 1.66667C7.61111 2.44444 8 3.38889 8 4.5C8 4.75556 7.97778 4.99711 7.93333 5.22467C7.88889 5.45267 7.82222 5.67778 7.73333 5.9L11.1 9.23333C11.2667 9.4 11.3918 9.58333 11.4753 9.78333C11.5584 9.98333 11.6 10.1944 11.6 10.4167C11.6 10.6389 11.5556 10.8527 11.4667 11.058C11.3778 11.2638 11.2556 11.4444 11.1 11.6C10.9333 11.7667 10.75 11.8889 10.55 11.9667C10.35 12.0444 10.1389 12.0833 9.91667 12.0833ZM9.7 10.6667C9.75555 10.7222 9.83067 10.7473 9.92533 10.742C10.0196 10.7362 10.0944 10.7056 10.15 10.65C10.2056 10.5944 10.2333 10.5196 10.2333 10.4253C10.2333 10.3307 10.2056 10.2556 10.15 10.2L6.1 6.16667C6.3 5.94444 6.44444 5.686 6.53333 5.39133C6.62222 5.09711 6.66667 4.8 6.66667 4.5C6.66667 3.83333 6.45289 3.25267 6.02533 2.758C5.59733 2.26378 5.06667 1.96667 4.43333 1.86667L5.66667 3.1C5.8 3.23333 5.86667 3.38889 5.86667 3.56667C5.86667 3.74444 5.8 3.9 5.66667 4.03333L3.53333 6.16667C3.4 6.3 3.24444 6.36667 3.06667 6.36667C2.88889 6.36667 2.73333 6.3 2.6 6.16667L1.36667 4.93333C1.46667 5.56667 1.764 6.09711 2.25867 6.52467C2.75289 6.95267 3.33333 7.16667 4 7.16667C4.28889 7.16667 4.57778 7.12222 4.86667 7.03333C5.15556 6.94444 5.41667 6.80556 5.65 6.61667L9.7 10.6667Z"
                                                    fill="#FF3D00"
                                                  />
                                                </svg>
                                              ) : (
                                                <svg
                                                  width="12"
                                                  height="13"
                                                  viewBox="0 0 12 13"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M9.91667 12.0833C9.69444 12.0833 9.48333 12.0418 9.28333 11.9587C9.08333 11.8751 8.9 11.75 8.73333 11.5833L5.4 8.23333C5.17778 8.32222 4.95289 8.38889 4.72533 8.43333C4.49733 8.47778 4.25556 8.5 4 8.5C2.88889 8.5 1.94444 8.11111 1.16667 7.33333C0.388889 6.55556 0 5.61111 0 4.5C0 4.1 0.0555555 3.71933 0.166667 3.358C0.277778 2.99711 0.433333 2.65556 0.633333 2.33333L3.06667 4.76667L4.26667 3.56667L1.83333 1.13333C2.15556 0.933333 2.49711 0.777778 2.858 0.666667C3.21933 0.555556 3.6 0.5 4 0.5C5.11111 0.5 6.05556 0.888889 6.83333 1.66667C7.61111 2.44444 8 3.38889 8 4.5C8 4.75556 7.97778 4.99711 7.93333 5.22467C7.88889 5.45267 7.82222 5.67778 7.73333 5.9L11.1 9.23333C11.2667 9.4 11.3918 9.58333 11.4753 9.78333C11.5584 9.98333 11.6 10.1944 11.6 10.4167C11.6 10.6389 11.5556 10.8527 11.4667 11.058C11.3778 11.2638 11.2556 11.4444 11.1 11.6C10.9333 11.7667 10.75 11.8889 10.55 11.9667C10.35 12.0444 10.1389 12.0833 9.91667 12.0833ZM9.7 10.6667C9.75555 10.7222 9.83067 10.7473 9.92533 10.742C10.0196 10.7362 10.0944 10.7056 10.15 10.65C10.2056 10.5944 10.2333 10.5196 10.2333 10.4253C10.2333 10.3307 10.2056 10.2556 10.15 10.2L6.1 6.16667C6.3 5.94444 6.44444 5.686 6.53333 5.39133C6.62222 5.09711 6.66667 4.8 6.66667 4.5C6.66667 3.83333 6.45289 3.25267 6.02533 2.758C5.59733 2.26378 5.06667 1.96667 4.43333 1.86667L5.66667 3.1C5.8 3.23333 5.86667 3.38889 5.86667 3.56667C5.86667 3.74444 5.8 3.9 5.66667 4.03333L3.53333 6.16667C3.4 6.3 3.24444 6.36667 3.06667 6.36667C2.88889 6.36667 2.73333 6.3 2.6 6.16667L1.36667 4.93333C1.46667 5.56667 1.764 6.09711 2.25867 6.52467C2.75289 6.95267 3.33333 7.16667 4 7.16667C4.28889 7.16667 4.57778 7.12222 4.86667 7.03333C5.15556 6.94444 5.41667 6.80556 5.65 6.61667L9.7 10.6667Z"
                                                    fill="#6FA03B"
                                                  />
                                                </svg>
                                              )
                                            }
                                            text={
                                              checkOverDue(counter_based_repitiotion_and_reminder ? targetNotification[0]?.notification.dueuntil : i.startingfrom)
                                                ? "Überfällig"
                                                : "Durchführbar"
                                            }
                                            textColor={
                                               checkOverDue(counter_based_repitiotion_and_reminder ? targetNotification[0]?.notification.dueuntil : i.startingfrom)
                                                ? "#FF3D00"
                                                : "#6FA03B"
                                            }
                                          />
                                        )}
                                      </div>
                                    </Link>
                                  )}
                                </>
                              )} */}
                            </TableCell>

                            <TableCell align="left">
                              {isCounterBasedMaintenanceTask ? (
                                i.repetitioninterval !== "" ? (
                                  <div>
                                    {GetRepetitionValue(i.repetitioninterval)}
                                    <br />
                                    {i?.triggeringevent?.[1] +
                                      " " +
                                      getCounterUnit(
                                        i?.triggeringevent?.[0],
                                        props.machines.equipment.hascounter
                                      )}
                                  </div>
                                ) : (
                                  <div>
                                    {i?.triggeringevent?.[1] +
                                      " " +
                                      getCounterUnit(
                                        i?.triggeringevent?.[0],
                                        props.machines.equipment.hascounter
                                      )}
                                  </div>
                                )
                              ) : (
                                GetRepetitionValue(i.repetitioninterval)
                              )}
                            </TableCell>
                            <TableCell align="left">
                              {isCounterBasedMaintenanceTask ? (
                                i.repetitioninterval !== "" ? (
                                  <div>{GetReminderValue(i.reminder)}</div>
                                ) : (
                                  <div></div>
                                )
                              ) : (
                                GetReminderValue(i.reminder)
                              )}
                            </TableCell>
                            <TableCell align="left">
                              <div
                                style={{
                                  lineHeight: "1.5",
                                  boxShadow:
                                    "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0)",
                                  display: "block",
                                  height: 18,
                                  width: 123,
                                  fontSize: 12,
                                  letterSpacing: 0.4,
                                  textAlign: "center",
                                  borderRadius: 20,
                                  background:
                                    i?.hascategory &&
                                    i?.hascategory[0]?.maintenancecategory
                                      ?.colorcode,
                                  fontWeight: "bold",
                                  color: "#FFFFFF",
                                }}
                              >
                                {i?.hascategory &&
                                  i?.hascategory[0]?.maintenancecategory?.name}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : i18n.no_maintenancetask}
                </TableBody>
              </Table>

              <div className="MO_customPagination">
                <div>
                  {paginationchunks.length > 0 ? (
                    <Pagination
                      count={paginationchunks.length}
                      shape="rounded"
                      onChange={handleChangePage}
                      hideNextButton={page === paginationchunks.length - 1}
                      hidePrevButton={page === 0}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      label="Zeilen pro Seite"
                    >
                      <MenuItem value={5}>5 Zeilen pro Seite</MenuItem>
                      <MenuItem value={10}>10 Zeilen pro Seite</MenuItem>
                      <MenuItem value={25}>25 Zeilen pro Seite</MenuItem>
                      <MenuItem value={50}>50 Zeilen pro Seite</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <EmptyState
          heading={"Routinewartungen"}
          title={"Sie haben noch keine Wartungen geplant"}
          description={
            "Routinewartungen werden in regelmäßigen Intervallen ausgeführt. Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung."
          }
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_2243_29890"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_2243_29890)">
                <path
                  d="M12 11.6L14.5 14.1C14.6833 14.2833 14.775 14.5167 14.775 14.8C14.775 15.0833 14.6833 15.3167 14.5 15.5C14.3167 15.6833 14.0833 15.775 13.8 15.775C13.5167 15.775 13.2833 15.6833 13.1 15.5L10.3 12.7C10.2 12.6 10.125 12.4875 10.075 12.3625C10.025 12.2375 10 12.1083 10 11.975V8C10 7.71667 10.0958 7.47917 10.2875 7.2875C10.4792 7.09583 10.7167 7 11 7C11.2833 7 11.5208 7.09583 11.7125 7.2875C11.9042 7.47917 12 7.71667 12 8V11.6ZM18 6H16C15.7167 6 15.4792 5.90417 15.2875 5.7125C15.0958 5.52083 15 5.28333 15 5C15 4.71667 15.0958 4.47917 15.2875 4.2875C15.4792 4.09583 15.7167 4 16 4H18V2C18 1.71667 18.0958 1.47917 18.2875 1.2875C18.4792 1.09583 18.7167 1 19 1C19.2833 1 19.5208 1.09583 19.7125 1.2875C19.9042 1.47917 20 1.71667 20 2V4H22C22.2833 4 22.5208 4.09583 22.7125 4.2875C22.9042 4.47917 23 4.71667 23 5C23 5.28333 22.9042 5.52083 22.7125 5.7125C22.5208 5.90417 22.2833 6 22 6H20V8C20 8.28333 19.9042 8.52083 19.7125 8.7125C19.5208 8.90417 19.2833 9 19 9C18.7167 9 18.4792 8.90417 18.2875 8.7125C18.0958 8.52083 18 8.28333 18 8V6ZM11 21C9.75 21 8.57917 20.7667 7.4875 20.3C6.39583 19.8333 5.44167 19.1917 4.625 18.375C3.80833 17.5583 3.16667 16.6042 2.7 15.5125C2.23333 14.4208 2 13.25 2 12C2 10.75 2.23333 9.57917 2.7 8.4875C3.16667 7.39583 3.80833 6.44167 4.625 5.625C5.44167 4.80833 6.39583 4.16667 7.4875 3.7C8.57917 3.23333 9.75 3 11 3C11.1833 3 11.3542 3.00417 11.5125 3.0125C11.6708 3.02083 11.8417 3.04167 12.025 3.075C12.3083 3.075 12.5458 3.17083 12.7375 3.3625C12.9292 3.55417 13.025 3.79167 13.025 4.075C13.025 4.35833 12.9292 4.59583 12.7375 4.7875C12.5458 4.97917 12.3083 5.075 12.025 5.075C11.8417 5.075 11.6708 5.0625 11.5125 5.0375C11.3542 5.0125 11.1833 5 11 5C9.03333 5 7.375 5.675 6.025 7.025C4.675 8.375 4 10.0333 4 12C4 13.9667 4.675 15.625 6.025 16.975C7.375 18.325 9.03333 19 11 19C12.9667 19 14.625 18.325 15.975 16.975C17.325 15.625 18 13.9667 18 12C18 11.7167 18.0958 11.4792 18.2875 11.2875C18.4792 11.0958 18.7167 11 19 11C19.2833 11 19.5208 11.0958 19.7125 11.2875C19.9042 11.4792 20 11.7167 20 12C20 13.25 19.7667 14.4208 19.3 15.5125C18.8333 16.6042 18.1917 17.5583 17.375 18.375C16.5583 19.1917 15.6042 19.8333 14.5125 20.3C13.4208 20.7667 12.25 21 11 21Z"
                  fill="black"
                  fillOpacity="0.5"
                />
              </g>
            </svg>
          }
          hasButton
          button={
            <div style={{ marginTop: "20px" }}>
              {canUserPerformAction(
                props.profile?.features?.["equipment.maintenancetask"],
                "create"
              ) && (
                <Link
                  to="/create-maintenance-task"
                  state={{
                    pageType: "add",
                    from: "fo",
                    nodeid: props?.machines?.equipment?.nodeid,
                    equipmentcurrency: props?.machines?.equipment?.equipmentcurrency,
                  }}
                >
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    color="primary"
                  >
                    {i18n.new_maintenance}
                  </Button>
                </Link>
              )}
            </div>
          }
        />
      )}
    </>
  );
});
